import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import { http } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// Lote 124 — faixa no Painel, só para o administrador, quando o backup não está em dia. Sem problema, não ocupa espaço.
const TXT = {
  nao_configurado: "O backup do banco ainda não está configurado.",
  nunca: "Nenhum backup chegou ao seu Mac ainda.",
  atrasado: "O backup está atrasado: faz mais de 48 horas sem cópia confirmada.",
};

export default function BackupAviso() {
  const { user } = useAuth();
  const [alerta, setAlerta] = useState(null);
  useEffect(() => {
    if (!user?.is_owner) return;
    http.get("/admin/backup/status").then((r) => setAlerta(r.data?.alerta || null)).catch(() => {});
  }, [user?.is_owner]);
  if (!user?.is_owner || !alerta) return null;
  return (
    <div role="alert" data-testid="backup-aviso-painel" data-alerta={alerta}
      className={`mb-4 flex items-start gap-3 rounded-md border px-4 py-3 text-sm ${alerta === "atrasado" ? "border-red-200 bg-red-50 text-red-900" : "border-amber-200 bg-amber-50 text-amber-900"}`}>
      <AlertTriangle className="w-4 h-4 mt-0.5 shrink-0" strokeWidth={2} />
      <div className="min-w-0">
        <p className="font-semibold">{TXT[alerta]}</p>
        <Link to="/admin" className="text-xs font-semibold underline">Abrir Administração &gt; Backup</Link>
      </div>
    </div>
  );
}
